import React, { useCallback } from 'react';
import styled from 'styled-components';
import { BaseButton } from './BaseButton';
import Color from 'color';
import { TagData } from './TagOptionsMap';

interface TagProps {
  selected: boolean;
  hasTouchSupport: boolean;
  theme: Theme;
}

const updateBgColorOnHover = (props: TagProps) => {
  let bgColor =!props.selected
    ? !props.hasTouchSupport
      ? Color('#000').alpha(0.1).string()
      : props.theme.ob_colors.secondary
    : '#000'
  
  return bgColor;
}

const Tag = styled(BaseButton)<TagProps>`
  display: flex;
  background-color: ${(props) => (props.selected ? '#000' : props.theme.ob_colors.secondary)};
  color: ${(props) => (props.selected ? '#fff' : '#000')};
  border: 2px solid ${(props) => '#000'};
  box-sizing: border-box;
  border-radius: 4px;
  font-size: 14px;
  padding: 0.45em;
  justify-content: center;
  align-items: center;
  margin: 2.5px;
  height: 2.4rem;
  max-width: 15rem;
  width: 90%;
  outline: none;
  cursor: pointer;

  @media (hover: hover) {
    &:hover {
      background-color: ${updateBgColorOnHover};
      color: ${(props) => (!props.selected ? '#000' : props.theme.ob_colors.secondary)};
    }
  }
`;

export const isTagSelected = (currentTag: TagData, tagSelection: TagData[]) => {
  return tagSelection.findIndex((selectedTag) => selectedTag.displayText === currentTag.displayText) >= 0;
};

const hasTouchSupport = 'ontouchstart' in window;

export const TagWrapper = ({ onTagClick, tag, tagSelection }) => {
  const onTagClicked = useCallback(() => onTagClick(tag), [onTagClick, tag]);
  const isTagClicked = isTagSelected(tag, tagSelection);

  return (
    <Tag
      aria-label={tag.displayText}
      aria-pressed={isTagClicked}
      tabIndex={0}
      onClick={onTagClicked}
      selected={isTagClicked}
      hasTouchSupport={hasTouchSupport}
    >
      {tag.displayText}
    </Tag>
  );
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/FiveStarSurvey/components/TagWrapper.tsx